const QWERTY_CHARS = "\\x20-\\x7E\\n\\r\\t";

export const QWERTY_PRINTABLE_REGEX = new RegExp(`^[${QWERTY_CHARS}]*$`);
const INVALID_QWERTY_CHAR_REGEX = new RegExp(`[^${QWERTY_CHARS}]`, "g");

export const isQwertyOnly = (value = ""): boolean =>
  QWERTY_PRINTABLE_REGEX.test(value);

export const stripNonQwertyChars = (value = ""): string =>
  value.replace(INVALID_QWERTY_CHAR_REGEX, "");

export interface QwertyTextRuleOptions {
  maxLength?: number;
  fieldLabel?: string;
}

export const qwertyTextRule = ({
  maxLength = 500,
  fieldLabel = "This field",
}: QwertyTextRuleOptions = {}) => ({
  validator(_: any, value: string) {
    if (!value) return Promise.resolve();
    if (value.length > maxLength) {
      return Promise.reject(
        new Error(`${fieldLabel} cannot exceed ${maxLength} characters`)
      );
    }
    if (!isQwertyOnly(value)) {
      return Promise.reject(
        new Error(`${fieldLabel} may only contain standard keyboard characters`)
      );
    }
    return Promise.resolve();
  },
});
